import React from "react";
import {BiChevronDown} from "react-icons/bi";
import {
    MDBBtn,
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBCard,
    MDBCardBody,
  }
  from 'mdb-react-ui-kit';
  import UploadCsv from "../component/UploadCsv";
  import ExpUploadCsv from "../component/excUploadfile";
  import RejectionUploadCsv from "../component/rejectionUploadfile";
  import { useState } from "react";
  import { useEffect } from "react";
  import Tab from 'react-bootstrap/Tab';
  import Tabs from 'react-bootstrap/Tabs';
  import Tnedata from "../services/data";
  //import ModalAlert from "../component/Modalalert";
  import ModalRejAlert from "../component/Modalrejalert";
 import { useNavigate } from "react-router-dom";
const UploadcsvPage = () =>{

  const [toggle, setToggle]=useState(false);
  const[open, setOpen] = useState(false)
  const[tabkey, setTabkey] = useState(false)
  const [logdata, setLogdata] = useState()
  const [exclogdata, setExcLogdata] = useState()
  const [rejclogdata, setRejcLogdata] = useState()
  const [rejclogdate, setRejcLogdate] = useState()
  const [qsetmsg, setQsetmsg] = useState(false)
  const [qdaycount, setQdaycount] = useState(false)
  const navigate = useNavigate();
  const user = sessionStorage.getItem("user")
  const onToggleclick =()=>{
    setToggle(!toggle)
  }

  //get Quarter month
  const getQuarter = (d) => {
    d = d || new Date();
    console.log(d)
    console.log(d.getMonth())

    var m = Math.floor(d.getMonth() / 3) + 1 ;
   // var y = d.getFullYear() ;
    return m;
  }
  const date2 = new Date();
  console.log(date2)

  console.log(getQuarter(date2))

  const fetchlog= async () => {
    const response = await Tnedata.getLog();
    if (response) {
      const comment    = response.data.filter(i=> i.file_type === 'expense');
      const exccomment = response.data.filter(i=> i.file_type === 'exception');
      const rejcomment = response.data.filter(i=> i.file_type === 'rejection');
      console.log(rejcomment)
      const excdate = exccomment.length > 0 ? exccomment[0].create_at: '' ;
      const rejdate = rejcomment.length > 0 ? rejcomment[0].create_at: '' ;
      console.log(excdate);
      setRejcLogdate(rejdate)
      setLogdata(comment);
      setExcLogdata(exccomment);
      setRejcLogdata(rejcomment);
      const date = new Date();
      const currquarter = getQuarter(date);
      const rejquarter = rejcomment.length > 0  ? getQuarter(new Date(rejdate)) :"none";
      console.log(rejdate)
      console.log(date)
      if(currquarter === rejquarter ){
       console.log("rejquarter:" ,rejquarter , "currquarter:", currquarter)
        setQsetmsg(true)
        setOpen(false)
      }else if(rejquarter === "none" || currquarter !== rejquarter){
        console.log("rejquarter:" ,rejquarter , "currquarter:", currquarter)
        setOpen(true)
        setQsetmsg(false)
      }
      //console.log(excdate)
      const dateDifferenceInDays  = (dateInitial, dateFinal) =>
        (dateFinal - dateInitial) / 86_400_000;
      //console.log(excdate.slice(0, 10))

      const startnextq = new Date(date.getFullYear(), currquarter * 3, 1);
      const startnextqd =startnextq.toISOString().split("T")[0]
      console.log(currquarter)

      const currd = date.toISOString().split("T")[0]
      const qdiffcount = dateDifferenceInDays(new Date(currd), new Date(startnextqd))
      setQdaycount(qdiffcount)
      //const excdatedate = excdate.slice(0, 10)
     // console.log(qdiffcount )

      //const endFullQuarter = new Date(startFullQuarter.getFullYear(), startFullQuarter.getMonth() + 3, 0);
    }
   //const quarter = Math.ceil(date.getMonth() / 3);
   // const rejquarter = Math.ceil(rejdate.getMonth() / 3);
  };
  // const handleSelect = (eventKey) => {
  //   setTabkey(eventKey)
  //   setOpen(true);
  // };

  useEffect(()=>{
     // Check session storage for "code"
     const sessioncode = sessionStorage.getItem("sessioncode");
     console.log(sessioncode);
     if (sessioncode === " ") {
      navigate('/');
     } 

    fetchlog()
    //setOpen(true)
  },[])
 

  
return(
<>
<MDBContainer fluid className={`${toggle ? 'vh-2 pt-2': 'vh' } background-radial-gradient overflow-hidden `}  >
    <MDBContainer className={`${toggle ? 'mt-2 pt-6 pb-3' : 'pt-4 ' }`}>
      <MDBRow>
      <MDBCol size='3'></MDBCol>
      <MDBCol size='6'>
      <Tabs defaultActiveKey="Expense Upload" id="uncontrolled-tab-example" className="mb-3" > {/* onSelect={handleSelect} */}
         {/*Expense Upload*/}
        <Tab eventKey="Expense Upload" title="Expense Upload">
          <MDBRow>
          <MDBCol className='position-relative'>
            <MDBCard className='mb-5 pb-0 bg-glass'>
              <MDBCardBody className='p-3 pb-3'>
                <UploadCsv toggle={toggle} logdata={logdata ?  logdata :  [{filename:"Loading..."}] }/>
                <MDBBtn style={{background:"transparent !important", boxShadow: "none", fontSize: "30px", position: "absolute", left: "38%", bottom: "-43px",
      zIndex: "0", border:"0px none !important"}} onClick={onToggleclick}>
        <p>GUIDE</p>
                  <BiChevronDown  style={{ color:"#2d446c"}}  className='bg-glass halfcirclebottom' />
                </MDBBtn>
              </MDBCardBody>
            </MDBCard>
            </MDBCol>
          </MDBRow>
        </Tab>
        {/*Exception Upload*/}
        <Tab eventKey="Exception Upload" title="Exception Upload">
        <MDBRow>
          <MDBCol className='position-relative'>
            <MDBCard className='mb-5 pb-0 bg-glass'>
              <MDBCardBody className='p-3 pb-3'>
                <ExpUploadCsv toggle={toggle} logdata={exclogdata ?  exclogdata :  [{filename:"Loading..."}] }/>
                <MDBBtn style={{background:"transparent !important", boxShadow: "none", fontSize: "30px", position: "absolute", left: "38%", bottom: "-43px",
      zIndex: "0", border:"0px none !important"}} onClick={onToggleclick}>
                  <p>GUIDE</p>
                  <BiChevronDown  style={{ color:"#2d446c"}}  className='bg-glass halfcirclebottom' />
                </MDBBtn>
              </MDBCardBody>
            </MDBCard>
            </MDBCol>
          </MDBRow>        
          </Tab>
           {/*re Upload*/}
        <Tab eventKey="Rejection Upload" title="Rejection Upload">
        <MDBRow>
          <MDBCol className='position-relative'>
            <MDBCard className='mb-5 pb-0 bg-glass'>
              <MDBCardBody className='p-3 pb-3'>
                {qsetmsg ? <><div style={{ fontSize:"15px"}}>Next Rejection upload will be avilable : <span style={{color:"purple", fontWeight:"bold"}}>{qdaycount} Days</span> </div> </>: 
                <>
                <RejectionUploadCsv toggle={toggle} logdata={rejclogdata ?  rejclogdata :  [{filename:"Loading..."}] }/>
                <MDBBtn style={{background:"transparent !important", boxShadow: "none", fontSize: "30px", position: "absolute", left: "38%", bottom: "-43px",
      zIndex: "0", border:"0px none !important"}} onClick={onToggleclick}>
                  <p>GUIDE</p>
                  <BiChevronDown  style={{ color:"#2d446c"}}  className='bg-glass halfcirclebottom' />
                </MDBBtn>
                </>
                }
              </MDBCardBody>
            </MDBCard>
            </MDBCol>
          </MDBRow>        
          </Tab>
      </Tabs>
      </MDBCol>
        <MDBCol size='3'>  
        {/* <ModalAlert show={open} onHide={() => setOpen(false)} tabkey={tabkey}/> */}
        <ModalRejAlert show={open} onHide={() => setOpen(false)} tabkey={tabkey}/> 
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    </MDBContainer>
</>
    );
}
export default UploadcsvPage;